(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('BlackoutPeriodDeleteController',BlackoutPeriodDeleteController);

    BlackoutPeriodDeleteController.$inject = ['$uibModalInstance', 'entity', 'BlackoutPeriod'];

    function BlackoutPeriodDeleteController($uibModalInstance, entity, BlackoutPeriod) {
        var vm = this;

        vm.blackoutPeriod = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            BlackoutPeriod.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
